import { CardContent, CardHeader,IconButton, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { useFieldDictionaryFormHandling } from "./components/FieldDictionaryStateHandle.js";
import { useEffect, useState } from "react"
import MaterialBox from "../../../components/MaterialBox/index.js"
import MaterialButton from "../../../components/MaterialButton/index.js"
import FieldDetailsAccordion from "./components/FieldDetailsAccordion.js"
import ValidationRulesAccordion from "./components/ValidationRulesAccordion.js"
import DisplayWidgetAccordion from "./components/DisplayWidgetAccordion.js"
import FieldClassificationAccordion from "./components/FieldClassificationAccordion.js"
import { fetchData, fetchDataById, postData, putData } from "../../../services/index.js"
import DropDownConfig from "../../Utils/DropDownConfig.js"

const FieldDictionaryForm = () => {

    const [searchParams] = useSearchParams();
    const fieldDictionaryId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    //accordian style
    const accordionSx = {
        bgcolor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: "none",
        "&:before": { display: "none" },
        mb: 1,
        "& .MuiAccordionSummary-root": {
            px: 2,  
            py: 1,
            "& .MuiAccordionSummary-content": {
            my: 0.2,
            },
        },
    };

    //descrtiption style
    const descriptionSx = {
        color: "text.secondary",
        mt: 0.5,
        whiteSpace: { xs: "normal", sm: "nowrap" },
    };

    const [expanded, setExpanded] = useState("fieldDetails");
    const [widgetTypeOptions, setWidgetTypeOptions] = useState([]);
    const [dataTypeOptions, setDataTypeOptions] = useState([]);
    const [generalProductOptions, setGeneralProductOptions] = useState([]);
    const [fieldCategoryOptions, setFieldCategoryOptions] = useState([]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, []);

    //get data by id
    useEffect(() => {
        if((pageMode === "add") || (!fieldDictionaryId)){
            return
        }
        const fetchFieldDictionaryDataById = async (fieldDictionaryId) => {
            try {
            const response = await fetchDataById(`/api-engine/field-dictionary/${fieldDictionaryId}`);
            const responseData = response?.data;
            
            if(response?.success){
                setFormData(prev => ({
                ...prev,
                //field details
                name: responseData.name || "",
                label: responseData.label || "",
                description: responseData.description || "",
                isRequired: responseData?.isRequired,
                isActive: responseData?.isActive,
                //validation rules
                minLength: responseData?.constraints?.minLength || "",
                maxLength: responseData?.widgetOptions?.maxLength || "",
                pattern: responseData?.constraints?.pattern || "",
                //display & widget
                placeholder: responseData?.widgetOptions?.placeholder || "",
                widgetMaxLength: responseData?.widgetOptions?.maxLength || "",
                //field classification                    
                widgetTypeId: {value: responseData?.widgetType?.id, label: responseData?.widgetType?.keyName},
                dataTypeId: {value: responseData?.dataType?.id, label: responseData?.dataType?.keyName},
                fieldCategoryId: {value: responseData?.fieldCategory?.id, label: responseData?.fieldCategory?.keyName},
                gProductId: {value: responseData?.product?.id, label: responseData?.product?.keyName},            

                // reset status fields
                nameStatus: responseData?.name ? "success" : "unchecked",
                labelStatus: responseData?.label ? "success" : "unchecked",
                descriptionStatus: responseData?.description ? "success" : "unchecked",
                
                minLengthStatus: responseData?.constraints?.minLength ? "success" : "unchecked",
                maxLengthStatus: responseData?.widgetOptions?.maxLength ? "success" : "unchecked",
                patternStatus: responseData?.constraints?.pattern ? "success" : "unchecked",
                
                placeholderStatus: responseData?.widgetOptions?.placeholder ? "success" : "unchecked",
                widgetMaxLengthStatus: responseData?.widgetOptions?.maxLength ? "success" : "unchecked",
                
                widgetTypeIdStatus: responseData?.widgetType?.id ? "success" : "unchecked",
                dataTypeIdStatus: responseData?.dataType?.id ? "success" : "unchecked",
                fieldCategoryIdStatus: responseData?.fieldCategory?.id ? "success" : "unchecked",
                gProductIdStatus: responseData?.product?.id ? "success" : "unchecked",
                }));
            }
            else{
                //throw error message
            }
            } catch (error) {
            console.error('Error fetching data by ID:', error);
            showSnackbar(error?.response?.data?.message,"error");
            }
        };
        fetchFieldDictionaryDataById(fieldDictionaryId);
    },[pageMode]);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            productResponse,
            dataTypeResponse,
            widgetTypeResponse,
            fieldCategoryResponse
            ] = await Promise.allSettled([
            fetchData(`/reference/general/key-value-store?code=${DropDownConfig?.generalProduct}&dropdown=true&isActive=true`),
            fetchData(`api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiDataType}`),
            fetchData(`/api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiWidgetType}`),
            fetchData(`/api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiFieldCategory}`)
            ]);
            
            const formattedProducts = productResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedDataTypes = dataTypeResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedWidgetTypes = widgetTypeResponse?.value?.data?.items?.map((item) => ({
                label: item?.keyName,
                value: item?.id,
            })) || [];

            const formattedFieldCategories = fieldCategoryResponse?.value?.data?.items?.map((item) => ({
                label: item?.keyName,
                value: item?.id,
            })) || [];
            
            setGeneralProductOptions(formattedProducts);
            setDataTypeOptions(formattedDataTypes);
            setWidgetTypeOptions(formattedWidgetTypes);
            setFieldCategoryOptions(formattedFieldCategories);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error Fetching Dropdown","warning");
        } finally {
            setCircleLoading(false);
        }
    };

    //post and put api function
    const handleSubmitFieldDictionary = async () => {
        const payload = {
            name: formData?.name,
            label: formData?.label,
            dataTypeId: formData?.dataTypeId?.value,
            constraints: {
                minLength: formData?.minLength,
                maxLength: formData?.maxLength,
                pattern: formData?.pattern
            },
            widgetTypeId: formData?.widgetTypeId?.value,
            widgetOptions: {
                placeholder: formData?.placeholder,
                maxLength: formData?.widgetMaxLength
            },
            fieldCategoryId: formData?.fieldCategoryId?.value,
            gProductId: formData?.gProductId?.value,
            description: formData?.description,
            isRequired: formData?.isRequired,
            isActive: formData?.isActive
        };
        //Update
        if(fieldDictionaryId){
            try {
                const response = await putData(`/api-engine/field-dictionary/${fieldDictionaryId}`, payload);
                console.log("putresponse",response);
                
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/api-integration-engine/field-dictionary');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Error Updating Body Type","error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/api-engine/field-dictionary', payload);                
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/api-integration-engine/field-dictionary');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                //catch error message
                console.error('Error posting data:', error);
                showSnackbar(error?.response?.data?.message || "Network Error","error")
            }
        }
    };

    const { formData, setFormData, handleChange, checkAllFields } = useFieldDictionaryFormHandling(); 

  return (
    <DashboardLayout>        
        <CardHeader
        title={
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
            <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => navigate("/api-integration-engine/field-dictionary")}>
                <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                    Field Dictionary Details
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                    Enter New Field Dictionary Details.
                </MaterialTypography>
                </Stack>
            </Stack>
            </Stack>
        }
        />
        <CardContent>
            {/* Field Details */}
            <FieldDetailsAccordion
            expanded={expanded === "fieldDetails"}
            onAccordionChange={setExpanded}
            formData={formData}
            handleChange={handleChange}
            pageMode={pageMode}
            accordionSx={accordionSx}
            descriptionSx={descriptionSx}
            />
            
            {/* Validation Rules */}
            <ValidationRulesAccordion
            expanded={expanded === "validationRules"}
            onAccordionChange={setExpanded}
            formData={formData}
            handleChange={handleChange}
            pageMode={pageMode}
            accordionSx={accordionSx}
            descriptionSx={descriptionSx}
            />
            
            {/* Display & Widget */}
            <DisplayWidgetAccordion
            expanded={expanded === "displayWidget"}
            onAccordionChange={setExpanded}
            formData={formData}
            handleChange={handleChange}
            pageMode={pageMode}
            accordionSx={accordionSx}
            descriptionSx={descriptionSx}
            widgetTypeOptions={widgetTypeOptions}
            setWidgetTypeOptions={setWidgetTypeOptions}
            />
            
            {/* Field Classification */}
            <FieldClassificationAccordion
            expanded={expanded === "fieldClassification"}
            onAccordionChange={setExpanded}
            formData={formData}
            handleChange={handleChange}
            pageMode={pageMode}
            accordionSx={accordionSx}
            descriptionSx={descriptionSx}
            generalProductOptions={generalProductOptions}
            dataTypeOptions={dataTypeOptions}
            fieldCategoryOptions={fieldCategoryOptions}
            />

        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/api-integration-engine/field-dictionary")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitFieldDictionary}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default FieldDictionaryForm